export const RESULT_HELP_TYPE = [
  {
    label: "ENUM.GOOD",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.NOTGOOD",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const SENT_TYPE_TEACHER = [
  {
    label: "ENUM.TRY_AGAIN",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.GET_PARENT",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.TO_GUID",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.TO_HOPITAL",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.TO_ROLE_GARD",
    value: 6,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const SENT_TYPE_GUID = [
  {
    label: "ENUM.TRY_AGAIN",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.GET_PARENT",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.TO_OTHER",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const RESULT_TYPE = [
  {
    label: "ENUM.SUCCESS",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAIL",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const STORY_TYPE = [
  {
    label: "ENUM.LERNING",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PERSONAL_SOCIAL",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.STUDY_AND_CAREER",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const CONSULTANT_TYPE = [
  {
    label: "ENUM.FACE_TO_FACE",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.ONLINE",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const EYE_OPTION = [
  {
    label: "ENUM.EYE_NORMAL",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.EYE_SHOT",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.EYE_SLOP",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.EYE_LONG",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const UESR_TYPE_OPTION = [
  {
    label: "ENUM.ADMIN",
    value: "Admin",
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.BUSINESS",
    value: "Business",
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.HUMAN",
    value: "Human",
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.ACCOUNT",
    value: "Account",
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.STUDENT",
    value: "Student",
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.TEACHER",
    value: "Teacher",
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const STUDENT_FILTER_DROPDOWN = [
  {
    label: "ENUM.NORMAL_SHORT",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.RISK_SHORT",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PROBLEM_SHORT",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const PERFOMANCE_TYPE_DROPDOWN = [
  {
    label: "ENUM.ACADEMIC",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.ART",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SPORT_E",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MUSIC",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.DANCE",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.CAREER",
    value: 6,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.LIFE_SKILL",
    value: 7,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SERVICE_MIND",
    value: 8,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 9,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const EDUCATION_STATUS = [
  {
    label: "ENUM.STUDING",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.CONGULATION",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const TEACHER_WORK_STATUS = [
  {
    label: "ENUM.COMPLETE",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.WORKING",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];


export const TEACHER_STATUS = [
  {
    label: "ENUM.TEACH",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OUT",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MOVE",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.ERNLY",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const TEACER_POSITION_NAME = [
  {
    label: "ENUM.DIRECTOR",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.TEACHER",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OFFICER",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHERINSCHOOL",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];


export const PRACTITIONER_NO = [
  {
    label: "ENUM.PRACTITIONER_1",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PRACTITIONER_2",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PRACTITIONER_3",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PRACTITIONER_4",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
   
];

export const ACTION_TEACH=[
  {
    label: "ENUM.SCIENCE_TEACH",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.COMPUTER_TEACH",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MATHEMATICS_TEACH",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.THAI_LANGUAGE_TEACH",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FOREIGN_LANGUAGE_TEACH",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SOCIAL_TEACH",
    value: 6,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.HEALT_TEACH",
    value: 7,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.ART_TEACH",
    value: 8,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.CAREER_TEACH",
    value: 9,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.GUID_TEACH",
    value: 10,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER_TEACH",
    value: 11,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
]

export const EDUCATION = [
  {
    label: "ENUM.PHD",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MASTER_DEGREE",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.ฺBACHELOR_DEGREE",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.DIPLOMA",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const GENDAR = [
  {
    label: "ENUM.MALE",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FEMALE",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const TEACHER_TITLE_EN = [
  {
    label: "ENUM.MR_EN",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MRS_EN",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OLDMISS_EN",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const TEACHER_TITLE = [
  {
    label: "ENUM.MR",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MRS",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OLDMISS",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const PARENT_TITLE = [
  {
    label: "ENUM.MR",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },

  {
    label: "ENUM.MRS",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OLDMISS",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },

];
export const MOTHER_TITLE = [
  {
    label: "ENUM.MRS",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OLDMISS",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },

];
export const FATHER_TITLE = [
  {
    label: "ENUM.MR",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const STUDENT_TITLE_EN = [
  {
    label: "ENUM.MR_EN",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OLDMISS_EN",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },

];
export const STUDENT_TITLE = [
  {
    label: "ENUM.MASTER",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MISS",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MR",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OLDMISS",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },



];
export const STUDENT_STATUS = [
  {
    label: "ENUM.STUDY",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.LEAVE",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.COMPLETE_STUDY",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PAUSE_STUDY",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const EDIT_REQUEST_STATUS = [
  {
    label: "ENUM.REQUEST",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.APPROVE",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.REJECT",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const CLASS_SPECIAL2 = [
  {
    label: "ENUM.SPECIAL_EP",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SPECIAL_ISMEP",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SPECIAL_SMTE",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MATH_SCINCE",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MATH_LANG",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.LANG_ENG",
    value: 6,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.LANF_CHAN",
    value: 7,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.LANG_JPN",
    value: 8,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 9,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
]
export const CLASS_SPECIAL1 =[
  {
    label: "ENUM.SPECIAL_EP",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SPECIAL_ISMEP",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SPECIAL_SMTE",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 9,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
]
export const BLOOD_TYPE = [
  {
    label: "ENUM.A",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.B",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.O",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.AB",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.A-",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.B-",
    value: 6,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.O-",
    value: 7,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.AB-",
    value: 8,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.A+",
    value: 9,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.B+",
    value: 10,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.O+",
    value: 11,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.AB+",
    value: 12,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const LIVE_WITH = [
  {
    label: "ENUM.DAD_AND_MOM",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.DAD",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MOM",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const FAMILY_STATUS = [
  {
    label: "ENUM.FAMILY_STATUS1",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAMILY_STATUS2",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAMILY_STATUS3",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAMILY_STATUS4",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAMILY_STATUS5",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAMILY_STATUS6",
    value: 6,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
 
  {
    label: "ENUM.FAMILY_STATUS7",
    value: 7,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAMILY_STATUS8",
    value: 8,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAMILY_STATUS9",
    value: 9,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FAMILY_STATUS10",
    value: 10,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const PARENTS_NUTURE_STUDENTS = [
  {
    label: "ENUM.STRICT",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.INDULGENT",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.USE_REASON",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.NEGLECT",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const FAMILY_MEMBER_RELATIONSHIP = [
  {
    label: "ENUM.HIGH_RELATIONSHIP",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.NORMAL_RELATIONSHIP",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.LOW_RELATIONSHIP",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const FAMILY_MEET_TIME = [
  {
    label: "ENUM.MORNIMG",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.NOON",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SUNSET",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const STUDENT_FAMMILY_MEMBER_CLOSEST = [
  {
    label: "ENUM.DAD",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.MOM",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OLD_SISTER",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.YOUNG_SISTER",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OLD_BROTHER",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.YOUNG_BROTHER",
    value: 6,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 7,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const COMMUNITY_ENVIROMENT = [
  {
    label: "ENUM.SAFE_ENVIROMENT",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.RISK_ENVIROMENT",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const VISIT_CARRIES = [
  {
    label: "ENUM.PRIVATE_CAR",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SCHOOL_BUS",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.BUS",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.WALK",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const RESIDENCE_ENVIROMENT = [
  {
    label: "ENUM.COMMERCIAL_BUILDING",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.ONE_WOOD",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.HALF_BUILD_WOOD",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.ONE_BUILD",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.TWO_WOOD",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 6,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const HOW_GO_SCHOOL = [
  {
    label: "ENUM.WALK",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OWN_WITHOUT_PAID",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.BUS_WITH_PAID",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SCHOOL_BUS_WITH_PAID",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.BICYCLE",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const HOME_SCHOOL_DISTANCE = [
  {
    label: "ENUM.DISTANCE_ONE",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.DISTANCE_TWO",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.DISTANCE_THREE",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.DISTANCE_FOUR",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.DISTANCE_FIVE",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
export const ROUTE_SCHOOL = [
  {
    label: "ENUM.GENERAL_STOR",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.GAME_STORE",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.FOREST",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.SWAMP",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const ROLE_IN_HOME = [
  {
    label: "ENUM.NOT_DO_ANYTHING",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PARTIME_JOB",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.HOME_WORK",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const HOBBIES = [
  {
    label: "ENUM.SPORT",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.READING",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PLAY_GAME",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.PLAY_MUSIC",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OTHER",
    value: 5,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const READ_FREQUENCY = [
  {
    label: "ENUM.ALWAYS_READ",
    value: 4,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.BEFORE_TEST",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.WHEN_TELL",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.NEVER_READ",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const SUPPLIE_STORAGE_FREQUENCY = [
  {
    label: "ENUM.BEST_STORAGE",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.GOOD_STORAGE",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.NEVER_STORAGE",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const WORK_BOOK_CHECKED_FREQUENCY = [
  {
    label: "ENUM.ALWAYS_CHECK",
    value: 3,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.OFFEN_CHECK",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.NEVER_CHECK",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];

export const EVIDENCE_TYPE = [
  {
    label: "ENUM.EVIDENCE_TYPE1",
    value: 1,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
  {
    label: "ENUM.EVIDENCE_TYPE2",
    value: 2,
    styleClass: null,
    icon: null,
    title: null,
    disabled: false,
  },
];
